export default "__VITE_ASSET__B7lbTn9D__"